export var ACTIVE_ICON_CLASS_NAME = 'active';
export var INACTIVE_ICON_CLASS_NAME = 'inactive';
export var RATING_ICON = 'star';